import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { CopyToClipboardProvider } from './CopyToClipboard.Context/provider.es.js';
import { CopyToClipboardInline } from './variants/CopyToClipboard.Inline.es.js';
import { CopyToClipboardInput } from './variants/CopyToClipboard.Input.es.js';

const CopyToClipboard = ({ className, label, locale, masked, message, value, variant = 'input', ...rest })=>jsx(CopyToClipboardProvider, {
        label: label,
        locale: locale,
        masked: masked,
        message: message,
        value: value,
        variant: variant,
        children: jsx("div", {
            className: classNames('cb-copy-to-clipboard', `${variant}-variant`, className),
            ...rest,
            children: variant === 'inline' ? jsx(CopyToClipboardInline, {}) : jsx(CopyToClipboardInput, {})
        })
    });
CopyToClipboard.displayName = 'CopyToClipboard';

export { CopyToClipboard, CopyToClipboard as default };
//# sourceMappingURL=CopyToClipboard.es.js.map
